export default __webpack_public_path__ + "static/r360-fisheye-animation.hevc-1a742454cc189ef7a1bc7d48ffd33cb4.mp4";